






















/* General */
import Vue from 'vue'
import MainContainer from '@/layouts/main-container.vue'

/* Mixins */

/* Components */
import RegistrationHeader from '@/views/registration-header.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */
import { IItemForSelection } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'RegistrationLayout',

  components: {
    RegistrationHeader,
    MainContainer,
  },

  props: {
    steps: {
      type: Array as () => IItemForSelection[],
      default: (): IItemForSelection[] => [],
    },
    stepId: {
      type: Number,
      default: 0,
    },
    size: {
      type: String,
      default: 'small',
    },
    revisitName: {
      type: String,
      default: '',
    },
    disableStepClicks: {
      type: Boolean,
      default: false,
    },
    hideNav: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      RouteAssistant,
    }
  },

  mounted() {
    const head = document.head
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src =
      'https://t.donedone.com/v1/lst/universal-script?ph=8255e0cf5770ad2c3da3318cfe3eccb945a0f2012e8e98d7573e02e8bbb71097&tag=!clicked'
    script.src += '&ref_url=' + encodeURI(document.URL)
    head.appendChild(script)
  },
})
